import React from 'react';
import "./App.scss"
import { routePath } from './common/routes';
import { Route, Routes } from 'react-router-dom';
import { WebContextProvider } from './contextProvider/webContextProvider';
import ErrorBoundary from './components/ErrorBoundary';

export const App =() => {

  return (
    <ErrorBoundary level="app">
    <React.Fragment>
      <WebContextProvider>
      <Routes>
        {routePath.map((route) => {
          return <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        })}
      </Routes>
      </WebContextProvider>
    </React.Fragment>
    </ErrorBoundary>

  )
}
